<div id="lesson">
    <div class="container-fluid ">
        <div class="row">
            <div class="col-md-3">
                <a routerLink="/courses/lesson-plan"> <i class="fas fa-long-arrow-alt-left"></i> Go Back</a>
                <nav id="secondary-navigation">
                    <!-- Header -->
                    <header class="header">
                        <h5>LESSON PLAN(2024-25)(Even Sem)</h5>
                    </header>
                    <!-- /Header -->
                    <ul>
                        <li *ngFor="let dept of departments" [class.active]="activeDepartment === dept.id">
                            <a (click)="changeRoute(dept.id)">{{ dept.name }}</a>
                          </li>

                    </ul>
                </nav>
            </div>
            <div class="col-md-9">
                <div id="sports">
                    <div class="container-fluid pdf">
                        <div class="row">
                            <div class="col-12">
                                <div class="card shadow-lg">

                                    <h5 class="card-title text-center">LESSON PLAN(2024-25)(Even Sem)</h5>
                                    <iframe [src]="src | safe" width="100%" height="1100" allow="autoplay"></iframe>

                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>